module.exports = __webpack_public_path__ + "static/media/mexico-icon.6ff2f855.svg";